// https://stackoverflow.com/a/43367791/1035039
// https://medium.com/@benlesh/rxjs-dont-unsubscribe-6753ed4fda87

import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { CurrencyMaskConstants } from './constants/currency-mask.constants';

export abstract class BaseClass implements OnDestroy {
    public CurrencyMaskConstants = CurrencyMaskConstants;

    protected stop$: Subject<boolean>;
    constructor() {
        this.stop$ = new Subject<boolean>();
        const f = this.ngOnDestroy;
        this.ngOnDestroy = () => {
            f.bind(this)();
            this.stop$.next(true);
            this.stop$.complete();
        };
    }
    /// placeholder of ngOnDestroy. no need to do super() call of extended class.
    ngOnDestroy() { }
}
